/**
 * Copy for the phase-1 GoTu Promo row (GOTU-6750 / GOTU-6751 / GOTU-5659).
 *
 * TODO(GOTU-5659): PLACEHOLDER COPY — NOT SIGNED OFF. The epic brief points at
 * tempmee_server#6506 for the spec, but that PR defines no UI strings. Confirm
 * the wording with design/product before shipping; this is a fee line, so the
 * string is user-visible on a receipt.
 *
 * GOTU-5659's promo-code apply flow (phase 2) uses the pattern
 * "GoTu Promo Code: [CODE]" once a code is entered. Phase 1 never renders a
 * code (it's always empty — automatic state/DSO discounts), so this label
 * stands alone with no code suffix.
 *
 * Deliberately one constant for all three surfaces. The sibling Counter Cover
 * label drifted into three spellings across these same files ('Gotu Counter
 * Cover:', 'GoTu Counter Cover', 'GoTu Counter Cover:'); new copy has no reason
 * to repeat that. Trailing punctuation is NOT part of the constant — each call
 * site adds the colon only where its neighbouring rows use one.
 */
export const PROMO_ROW_LABEL = 'GoTu Promo';
